import { render } from "./ItemAlunoSelecionado.vue?vue&type=template&id=6499a98c"
import script from "./ItemAlunoSelecionado.vue?vue&type=script&lang=js"
export * from "./ItemAlunoSelecionado.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__